var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2905 12.176L18.3048 20.1903C18.8255 20.712 19.6693 20.712 20.19 20.1903C20.7118 19.6686 20.7118 18.8258 20.19 18.3051L12.1758 10.2908L20.19 2.27652C20.7118 1.75479 20.7118 0.913028 20.19 0.391298C19.6693 -0.130432 18.8255 -0.130433 18.3048 0.391298L10.2905 8.40557L2.27627 0.391298C1.75556 -0.130432 0.912769 -0.130432 0.391039 0.391298C0.130689 0.651648 0 0.992265 0 1.33391C0 1.67556 0.130689 2.0172 0.391039 2.27652L8.40531 10.2908L0.39104 18.3051C0.130689 18.5644 3.03599e-07 18.906 3.03599e-07 19.2477C3.03599e-07 19.5893 0.130688 19.9299 0.391039 20.1903C0.912769 20.712 1.75557 20.712 2.27627 20.1903L10.2905 12.176Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.f6349382.svg";
export { ForwardRef as ReactComponent };